import React, { useState } from "react";

import { PositionsOrVirtualPortfolioPlanStats } from "@fartherfinance/frontend/api/Investment/request/postPositionsOrVirtualPortfolioPlanStats";

import NoDataSet from "@src/multiCustodian/components/Portfolios/NoDataSet";
import PortfolioHistoricalScenariosTable from "@src/multiCustodian/components/Portfolios/PortfolioHistoricalScenariosTable/PortfolioHistoricalScenariosTable";
import PortfolioMetricsTable from "@src/multiCustodian/components/Portfolios/PortfolioMetricsTable/PortfolioMetricsTable";
import Conditional from "@src/sharedComponents/Conditional/Conditional";
import ItemWithExpandCollapseContent from "@src/sharedComponents/ItemWithExpandCollapseContent/ItemWithExpandCollapseContent";
import { TabContext, TabPanel } from "@src/sharedComponents/Tabs/Tabs";
import TwoTextItemToggle from "@src/sharedComponents/Toggle/v2/TwoTextItemToggle";

import styles from "./Stats.module.css";

interface Props {
  isLoading: boolean;
  hasError: boolean;
  data: PositionsOrVirtualPortfolioPlanStats | undefined;
  hideMetricVisibilityTogglesAndShowAllStats?: boolean;
}

type TabValue = "Left" | "Right"; // Left=Metrics, Right=Historical Scenarios

const PortfolioDetailsSideBarStatsSection: React.FC<Props> = ({
  isLoading,
  hasError,
  data,
  hideMetricVisibilityTogglesAndShowAllStats = false,
}) => {
  const [expandStats, setExpandStats] = useState<boolean>(true);
  const [tab, setTab] = useState<TabValue>("Left");

  if (hasError === true) {
    return (
      <ItemWithExpandCollapseContent
        label={"Stats"}
        expand={expandStats}
        setExpand={setExpandStats}
      >
        <NoDataSet text={"Error loading stats"} iconColor={"error"} />
      </ItemWithExpandCollapseContent>
    );
  }

  if (isLoading === false && data === undefined) {
    return (
      <ItemWithExpandCollapseContent
        label={"Stats"}
        expand={expandStats}
        setExpand={setExpandStats}
      >
        <NoDataSet text={"Data set empty"} iconColor={"info"} />
      </ItemWithExpandCollapseContent>
    );
  }

  return (
    <ItemWithExpandCollapseContent
      label={"Stats"}
      expand={expandStats}
      setExpand={setExpandStats}
    >
      <TabContext value={tab}>
        <Conditional condition={true}>
          <TwoTextItemToggle
            className={styles.twoItemToggleButton}
            leftText={"Metrics"}
            rightText={"Historical Scenarios"}
            selected={tab}
            onChange={(newSelected: "Left" | "Right") => setTab(newSelected)}
          />
        </Conditional>

        <TabPanel value={"Left"}>
          <PortfolioMetricsTable
            isLoading={isLoading}
            hasError={hasError}
            data={data}
            hideMetricVisibilityTogglesAndShowAllStats={
              hideMetricVisibilityTogglesAndShowAllStats
            }
          />
        </TabPanel>
        <TabPanel value={"Right"}>
          <PortfolioHistoricalScenariosTable
            isLoading={isLoading}
            hasError={hasError}
            data={data}
          />
        </TabPanel>
      </TabContext>
    </ItemWithExpandCollapseContent>
  );
};

export default PortfolioDetailsSideBarStatsSection;
